export const footerReverseAtSizes = {
    large: 'large',
    medium: 'medium',
    none: 'none',
    small: 'small',
};
export const footerStackAtSizes = {
    large: 'large',
    medium: 'medium',
    none: 'none',
    small: 'small',
};
export const footerTypes = {
    primary: 'primary',
    secondary: 'secondary',
};
export const sizes = {
    medium: 'medium',
    small: 'small',
};
export const widths = {
    medium: 760,
    small: 480,
};
